export default __webpack_public_path__ + "static/media/flipkart.7f1808ce.png";